// extracted by mini-css-extract-plugin
module.exports = {"cardRoot":"card_cardRoot__vE-NF","title":"card_title__3SQtk","content":"card_content__3fV0v"};